import { useEffect, useState } from "react";
import { getHardwareShippingRates } from "src/billinglatest/clients/service.client";
import { Device, ShippingRate } from "./shippingRates";

export interface UseShippingRates {
  rates: ShippingRate[];
  loading: boolean;
  error: boolean;
}

/**
 * Loads the PIXI hardware shipping rates once on mount via the billing SDK
 * (`getHardwareShippingRates`). The selected-country amount is derived from
 * `rates` via `shippingAmountFor`.
 */
export const useShippingRates = (): UseShippingRates => {
  const [rates, setRates] = useState<ShippingRate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(false);
      try {
        const result = await getHardwareShippingRates(Device.Pixi);
        if (!cancelled) setRates(result);
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return { rates, loading, error };
};
